import {
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { PatientEncounterDTO } from 'types/patients';

const initialState: PatientEncounterDTO | null = null;

export const patientSlice = createSlice({
  name: 'patient',
  initialState,
  reducers: {
    patientAction: (state, action: PayloadAction<any>) => ({ ...action.payload }),
  },
});

// Action creators are generated for each case reducer function
export const { patientAction } = patientSlice.actions;

export default patientSlice.reducer;
